import HomeIcon from 'react-feather/dist/icons/home';
import ListIcon from 'react-feather/dist/icons/list';
import InfoIcon from 'react-feather/dist/icons/info';

const menu = [
  ,
  { label: 'Innehållsförteckning', to: '/content', icon: ListIcon },  
  { label: '', to: '/', icon: HomeIcon }
];

export default menu;
